exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-full-width{\n\twidth:100%;\n}\n.store-name { font-size: 16px; font-weight: 500; color: #111; }\n.product-notes {\n\tmargin-bottom: 5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-store-product/store-cart/store-cart.component.css
// module id = ../../../../../src/app/mnt-store-product/store-cart/store-cart.component.css
// module chunks = mnt-store-product.module